export default __webpack_public_path__ + "static/media/hanks.9f259857.gif";